import React, { useState, useEffect, useRef } from "react";
import {
    Grid,
    CssBaseline,
    Card,
    Typography,
    Avatar,
    Badge,
    Button,
    IconButton,
    Paper,
    Container,
    Chip,
    Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

import { useNavigate, useParams } from 'react-router-dom';
import { safeDecryptId } from '../utils/safeDecryptId';
import { getMentorStudentData, uploadProfileImage } from "../services";
import { useAuth } from "../context/AuthContext";
const theme = createTheme();

const styles = {
    details: {
        padding: "1rem",
        borderTop: "1px solid #e1e1e1"
    },
    value: {
        padding: "1rem 2rem",
        borderTop: "1px solid #e1e1e1",
        color: "#899499"
    }
};

export default function StudentProfile() {
    const [rows, setRows] = useState([]);
    const [userdata, setUserdata] = useState([]);
    const [studentid, setstudentid] = useState("");
    const [imagePreview, setImagePreview] = useState(null);
    const [open, setOpen] = useState(false);
    const fileInputRef = useRef(null);
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const { id: encryptedId } = useParams();
    const navigate = useNavigate();
    const user = {
        title: "Student at Harvard",
        dt1: "Semester 5",
        dt2: "GPA: 3.8",
        dt3: "Credits: 92",
        firstName: "Pratham",
        lastName: "Doe",
        midName: "Baker",
        gender: "female",
        phone: "932-555-4247",
        email: "janedoe@gmail.com",
        pass: "password123"
    };
    const { authdetails } = useAuth()
    const ID = authdetails.id;

    const fetchData = async () => {
        try {
            const res = await getMentorStudentData(ID, "student");
            setRows(res.data);
            setUserdata(res.data[0].user);
        } catch (err) {
            console.error('Error fetching mentors:', err);
        }
    };

    const fullName = authdetails.name;
    useEffect(() => {
        const decryptedId = safeDecryptId(encryptedId, secretKey);
        if (!decryptedId) {
            // navigate("/unauthorized");
            return;
        }
        setstudentid(decryptedId);
        // fetchData();
    }, [encryptedId, secretKey]);
    useEffect(() => {
        //  if (studentid) {
        fetchData();
        //  }
    }, []);
    const handleIconClick = () => {
        setOpen(true);
    };
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setImagePreview(reader.result); // for local preview
        };
        reader.readAsDataURL(file);

        // 🔄 Upload to API
        const formData = new FormData();
        formData.append("profile", file);
        formData.append("user_id", userdata.id);

        try {
            const response = await uploadProfileImage(formData);
            setOpen(false); // close dialog after upload
            window.location.reload();
        } catch (error) {
            console.error("Upload failed", error);
        }
    };
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="xl" sx={{ mt: 4, mb: 10 }}>
                {/* Cover Image */}
                <img
                    alt="cover"
                    style={{
                        width: "100%",
                        height: "30vh",
                        objectFit: "cover",
                        borderRadius: "10px"
                    }}
                    src="https://iris2.gettimely.com/images/default-cover-image.jpg"
                />

                {/* Profile & Settings */}
                <Grid container spacing={3} sx={{ mt: -15 }}>
                    {/* Profile Card */}
                    <Grid item xs={12} md={3} sx={{ ml: 3 }}>
                        <Card variant="outlined">
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item sx={{ p: "1.5rem 0rem", textAlign: "center" }}>
                                    
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                        badgeContent={
                                            <IconButton color="primary" onClick={handleIconClick}>
                                                <PhotoCameraIcon
                                                    sx={{
                                                        border: "5px solid white",
                                                        backgroundColor: "#ff558f",
                                                        borderRadius: "50%",
                                                        padding: ".2rem",
                                                        width: 35,
                                                        height: 35,
                                                    }}
                                                />
                                            </IconButton>
                                        }
                                    >
                                        <Avatar
                                            src={userdata.profile || undefined} // If profileImage is null, it shows initials
                                            sx={{
                                                width: 100,
                                                height: 100,
                                                mb: 1,
                                                background: !userdata.profile ? "linear-gradient(to right, #0f9ba1, #8ee3a8)" : "transparent",
                                                color: !userdata.profile ? "white" : "transparent",
                                                fontWeight: 'bold',
                                                fontSize: 32,
                                            }}
                                        >
                                            {!user.profile &&
                                                fullName
                                                    .split(' ')
                                                    .map(word => word[0]?.toUpperCase())
                                                    .join('')
                                            }
                                        </Avatar>
                                    </Badge>
                                    <Typography variant="h6">{userdata.name}</Typography>
                                    {/* <Typography color="text.secondary">{user.title}</Typography> */}
                                </Grid>
                                <Grid container sx={{ textAlign: "left" }} >
                                    <Grid item xs={4}>
                                        {userdata.email ? <Typography style={styles.details}>Email</Typography> : " "}

                                        {/* <Typography style={styles.details}>Mobile No.</Typography> */}
                                    </Grid>
                                    <Grid item xs={8} sx={{ textAlign: "left" }}>
                                        <Typography style={styles.value}>{userdata.email}</Typography>
                                        {/* <Typography style={styles.value}>{user.phone}</Typography> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>

                    {/* Settings Form */}
                    <Grid item xs={12} md={8} mt={10}>
                        {rows.length > 0 ? (rows.map((item, index) => (
                            <Paper elevation={3} sx={{
                                p: 5, mb: 4, background: "linear-gradient(to right, #0f9ba1, #8ee3a8)",
                                color: "white",
                            }} key={index}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                            Mentor Name
                                        </Typography>
                                        <Typography variant="body1" sx={{ border: "1px solid #ccc", borderRadius: "4px", padding: "10px", mt: 0.5 }}>
                                            {item.mentor?.name || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                            Mentor University
                                        </Typography>
                                        <Typography variant="body1" sx={{ border: "1px solid #ccc", borderRadius: "4px", padding: "10px", mt: 0.5 }}>
                                            {item.mentor?.college || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                            Meeting Price
                                        </Typography>
                                        <Typography variant="body1" sx={{ border: "1px solid #ccc", borderRadius: "4px", padding: "10px", mt: 0.5 }}>
                                            £{item?.price || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                            Meeting Date
                                        </Typography>
                                        <Typography variant="body1" sx={{ border: "1px solid #ccc", borderRadius: "4px", padding: "10px", mt: 0.5 }}>
                                            {item.mentor_time_mapping_tb?.date || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                            Meeting Timing
                                        </Typography>
                                        <Typography variant="body1" sx={{ border: "1px solid #ccc", borderRadius: "4px", padding: "10px", mt: 0.5 }}>
                                            {item.mentor_time_mapping_tb?.hour?.slot_time?.slice(0, 5) || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                            Status
                                        </Typography>
                                        <Chip
                                            label={item.isaccepted ? "Accepted" : "Pending"}
                                            color={item.isaccepted ? "success" : "warning"}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        ))) : (
                            <Typography variant="h6" textAlign="center" mt={5} color="red">
                                No meetings booked
                            </Typography>
                        )}
                    </Grid>

                </Grid>
                <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{
                    sx: {
                        background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                        color: 'white',
                        borderRadius: "15px"
                    },
                }}>
                    <DialogTitle>Upload Profile Picture</DialogTitle>
                    <DialogContent >
                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            style={{ marginTop: '20px' }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)}>Cancel</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </ThemeProvider>
    );
}
